<template>
  <div>
    <v-container>
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card v-if="!overlay" flat class="py-3 px-3">
            <v-card-text class="pt-0">
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <h2 class="compeatfont">Demo Subscriptions</h2>
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
            </v-card-text>

            <v-card-title class="pt-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Clients"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn @click="createDemoReport()" class="primary" small rounded>Create Demo</v-btn>
            </v-card-title>
            <v-data-table
              v-if="this.$store.state.user.resellerUid"
              :headers="headers"
              :items="demoResellerReports"
              :search="search"
              :items-per-page="10"
              :loading="overlay"
              loading-text="Loading... Please wait"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-btn @click="viewDemoSubscription(item)" icon color="primary"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
            </v-data-table>

            <v-data-table
              v-else
              :headers="headers"
              :items="demoSubscriptions"
              :search="search"
              :items-per-page="10"
              :loading="overlay"
              loading-text="Loading... Please wait"
            >
            <!-- <template v-slot:[`item.package`]="{ item }">
              {{item.package.primaryPage}}
            </template> -->
            <template v-slot:[`item.competitiveReport`]="{ item }">
              <v-icon v-if="item.reportIds.competitiveReportIds != ''" color="primary" @click="viewCompetitiveReport(item, item.reportIds.competitiveReportIds[0].reportId )">mdi-eye</v-icon>
              <!-- <p class="mb-0" v-if="item.reportIds.competitiveReportIds != ''"> {{ item.reportIds.competitiveReportIds[0].reportId }}</p> -->
             <p class="mb-0" v-else> N/A</p>
            </template>

            <template v-slot:[`item.insightsFb`]="{ item }">
              <v-icon v-if="item.reportIds.insightsReportIds != ''" color="primary" @click="viewInsightsFbReport(item, item.reportIds.insightsReportIds[0].reportId)">mdi-eye</v-icon>
             <!-- <p class="mb-0" v-if="item.reportIds.insightsReportIds != ''"> {{ item.reportIds.insightsReportIds[0].reportId }}</p> -->
             <p class="mb-0" v-else> N/A</p>
            </template>
            <template v-slot:[`item.insightsIg`]="{ item }">
              <v-icon v-if="item.reportIds.instagramReportIds != ''" color="primary" @click="viewInsightsIgReport(item, item.reportIds.instagramReportIds[0].reportId)">mdi-eye</v-icon>
             <p class="mb-0" v-else> N/A</p>
            </template>

            <template v-slot:[`item.isActive`]="{ item }">
              <v-chip class="ma-2" color="warning"> Pending </v-chip>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn @click="viewDemoSubscription(item)" icon color="primary"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card>
          <v-skeleton-loader
            v-else
            height="372px"
            class="mx-auto"
            type="table-heading, table-thead, table-tbody, table-tfoot"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "@/components/alerts/generalAlert.vue";
const moment = require("moment-timezone");

import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
export default {
  components: {
    generalAlert,
  },
  data: () => ({
    //Skeleton loading
    overlay: false,
    //Table Data and varibles
    demoSubscriptions: [],
    demoResellerReports: [],
    //For general alert on adding new user
    successResponse: "",
    alertType: "",
    alert: false,
    //Search field and data for table
    search: "",
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package.currentPackage", align: "center" },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: true,
        align: "center",
      },
      { text: "Competitive Report", value: "competitiveReport", sortable: false, align: "center" },
      { text: "Insights FB", value: "insightsFb", sortable: false, align: "center" },
      { text: "Insights IG", value: "insightsIg", sortable: false, align: "center" },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],

    //sales people for demo report popup
    salesPeople: [],
  }),
  created() {
    this.getAllDemoSubscriptions()
    // if (this.$store.state.user.resellerUid) {
    //   console.log("get demo reports");
    //   this.getAllResellerDemoRports();
    // } else {
    //   this.getAllDemoSubscriptions();
    // }
  },
  methods: {
    //Gets all users and filters it out on userType
    async getAllDemoSubscriptions() {
      this.overlay = true;
      this.demoSubscriptions = [];
      try {
        const querySnapshot = await getDocs(collection(db, "subscriptions"));
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();

          let createdMilliseconds = subscription.dateCreated;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
            subscription.dateCreated = formatCreatedDate;

          if (
            (subscription.agencyId === this.$store.state.agency.agencyId &&
              this.$store.state.user.userType == "AA" && subscription.package.packageType != "CompEatPaid" ) ||
            (subscription.agencyId === this.$store.state.agency.agencyId &&
              this.$store.state.user.userType == "SMM" && subscription.package.packageType != "CompEatPaid")
          ) {
            this.demoSubscriptions.push(subscription);
          } else if (this.$store.state.user.userType == "SA") {
            this.demoSubscriptions.push(subscription);
          }
        });

        // Sort the array by date
        this.demoSubscriptions.sort((a, b) => {
          return new Date(b.dateCreated) - new Date(a.dateCreated);
        });

        // this.getDemosreports

        this.getAgencySalesPeople();
      } catch (error) {
        console.log(error);
      }
    },
    // async getDemosreports(){
    //   let hey = []
    //   const querySnapshot = await getDocs(collection(db, "demoreports"));
    //     querySnapshot.forEach((doc) => {
    //       let subscription = doc.data();

    //       // console.log('subscription.packagePages[0].name', subscription.packagePages + subscription.reportId)

    //       let createdMilliseconds = subscription.createdAt;
    //       let formatCreatedDate =
    //         moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
    //         subscription.createdAt = formatCreatedDate;

    //       if (
    //         (subscription.packagePages[0].name === 'H2O BWT Africa')
    //       ) {
    //         hey.push(subscription);
    //       } else if (this.$store.state.user.userType == "SA") {
    //         hey.push(subscription);
    //       }
    //     });
    //     console.log(hey)
    // },
    //Get all resellers demo reports
    // async getAllResellerDemoRports() {
    //   this.overlay = true;
    //   this.demoResellerReports = [];
    //   const q = query(
    //     collection(db, "demoreports"),
    //     where("agencyId", "==", this.$store.state.user.agencyId),
    //     where("salesPerson", "==", this.$store.state.user.id) // Add another where clause as needed
    //   );

    //   const querySnapshot = await getDocs(q);
    //   querySnapshot.forEach((doc) => {
    //     let demoReport = doc.data();

    //     let createdMilliseconds = demoReport.createdAt;
    //     let formatCreatedDate =
    //       moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
    //     demoReport.createdAt = formatCreatedDate;

    //     this.demoResellerReports.push(demoReport);
    //   });

    //   // Sort the array by date
    //   this.demoResellerReports.sort((a, b) => {
    //     return new Date(b.createdAt) - new Date(a.createdAt);
    //   });

    //   this.overlay = false;
    // },
    //Get all agency sales users
    async getAgencySalesPeople() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let user = doc.data();

          if (
            user.agencyId == this.$store.state.agency.agencyId &&
            user.userType == "AS"
          ) {
            this.salesPeople.push(user);
          }
          this.overlay = false;
        });
      } catch (err) {
        console.log("getAgencySalesPeople err", err);
      }
    },
    //Alert functions to display response from adding new user
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAllDemoSubscriptions();
        this.alert = false;
      }, 3000);
    },
    //View the demo report
    viewDemoSubscription(item) {
      this.$router.push({
        name: "singleSubscription",
        params: {
          id: this.$store.state.user.agencyId,
          uid: item.uid,
        },
      });
    },
    viewCompetitiveReport(item, reportId) {
      this.$router.push({
        name: "singleReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    viewInsightsFbReport(item, reportId) {
      this.$router.push({
        name: "insightsReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    viewInsightsIgReport(item, reportId) {
      this.$router.push({
        name: "instagramInsightsReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    createDemoReport() {
      this.$router.push({
        name: "createSingleSubscription",
        params: {
          title: "package-demo",
        },
      });
    },
  },
};
</script>
